export default {
  sm: `
  DATA IN OUR 
  EVERYDAY
  LIVES
  `,
  md: `
  DATA IN 
  OUR EVERYDAY
  LIVES
  `,
};
